module.exports = __webpack_public_path__ + "img/specimen-dark.d66d1501.png";